export default "__VITE_ASSET__08ed5af1__"